// extracted by mini-css-extract-plugin
export default {"root":"styles_root__PMrtc","title_content":"styles_title_content__shYnk"};